import { createContext } from "react";

const TokenContext = createContext({
  token: "",
  isLoading: false,
  validToken: false,
  refresh: () => void 0,
});

export default TokenContext;
